import NiceModal from '@ebay/nice-modal-react';
import { Outlet } from 'react-router-dom';
import Navigation from '../Navigation/Navigation';

export const HomeLayout = () => {
  return (
    <div className="flex flex-col w-full">
      <NiceModal.Provider>
        <Navigation />
        <Outlet />
      </NiceModal.Provider>
    </div>
  );
};
